import { render } from "./index.vue?vue&type=template&id=30e50a7a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/button/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30e50a7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30e50a7a', __exports__)) {
    api.reload('30e50a7a', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=30e50a7a", () => {
    api.rerender('30e50a7a', render)
  })

}


export default __exports__